<script>
    import { _ } from "svelte-i18n";
    import { replace } from "svelte-spa-router";
    import DefaultButton from "../components/DefaultButton.svelte";
    import GeneralDetailPage from "./GeneralDetailPage.svelte";
</script>

<GeneralDetailPage title="Error">
    <div slot="content">
        <span class="text-l" style="font-size: 24px;">
            {$_("not_found_message")}
        </span>
    </div>

    <div slot="floatingButton">
        <DefaultButton
            on:click={() => replace("/")}
            text={$_("dashboard_title")}
        />
    </div>
</GeneralDetailPage>
